"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_1 = __importStar(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var Checkbox_1 = __importDefault(require("@/Jetstream/Checkbox"));
var Input_1 = __importDefault(require("../../Jetstream/Input"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
var react_i18next_1 = require("react-i18next");
var axios_1 = __importDefault(require("axios"));
var classnames_1 = __importDefault(require("classnames"));
var AuthPages_module_css_1 = __importDefault(require("./AuthPages.module.css"));
var front_end_validation_1 = __importDefault(require("@nordicscreen/front-end-validation"));
var SSO_1 = __importDefault(require("@/Components/Auth/SSO"));
function Register(props) {
    var _a, _b, _c;
    var logger = q_play_core_1.logManager.getLogger();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var defaultErrors = { email: "", phoneNumber: "", password: [], confirmPassword: "" };
    var serverErrors = {};
    var route = (0, useRoute_1.default)();
    var form = (0, inertia_react_1.useForm)({
        name: "",
        company_name: (_a = props.accountName) !== null && _a !== void 0 ? _a : "",
        email: (_b = props.invitedEmail) !== null && _b !== void 0 ? _b : "",
        phone_number: "",
        password: "",
        password_confirmation: "",
        terms: false,
        reCaptcha: false,
        partnerAccountId: (_c = props.partnerAccountId) !== null && _c !== void 0 ? _c : undefined
    });
    var _d = (0, react_1.useState)(defaultErrors), errors = _d[0], setErrors = _d[1];
    var _e = (0, react_1.useState)(serverErrors), sErrors = _e[0], setSErrors = _e[1];
    var isValid = function (errors) {
        Object.values(errors).forEach(function (val) {
            if (!Array.isArray(val) && val.length > 0)
                return false;
            if (Array.isArray(val)) {
                Object.values(val).forEach(function (valArr) {
                    if (valArr)
                        return false;
                });
            }
        });
        return true;
    };
    function formSubmit(e) {
        e.preventDefault();
        if (form.data.reCaptcha) {
            if (isValid(errors)) {
                form.post(route("register"), {
                    onError: function (e) {
                        setSErrors(e);
                    },
                    onSuccess: function () {
                        form.reset("password", "password_confirmation");
                        window.dispatchEvent(new CustomEvent("refresh-user-permissions"));
                    }
                });
            }
        }
        else {
            logger.warn("Missing recaptcha check");
            // inform missing recaptcha check
        }
    }
    function inputValidation(event) {
        event.preventDefault();
        var _a = event.target, id = _a.id, value = _a.value;
        var paswordErrors = [];
        var emailErrorValue = "";
        switch (id) {
            case "email":
                try {
                    new front_end_validation_1.default(value).validate("should.be.email", t("Email is not valid")).check();
                }
                catch (e) {
                    emailErrorValue = e[0].message;
                }
                setErrors(function (errors) { return (__assign(__assign({}, errors), { email: emailErrorValue })); });
                break;
            case "phone_number":
                if (!/^\+?[0-9()\- ]{1,}$/g.test(value)) {
                    setErrors(function (errors) { return (__assign(__assign({}, errors), { phoneNumber: t("Phone number is not a valid number") })); });
                }
                else {
                    setErrors(function (errors) { return (__assign(__assign({}, errors), { phoneNumber: "" })); });
                }
                break;
            case "password":
                if (value.length < 8) {
                    paswordErrors.push(t("The password must be at least 8 characters long"));
                }
                if (!value.match(/^(?=.*[A-Z])/)) {
                    paswordErrors.push(t("The password should have at least one uppercase letter"));
                }
                if (!value.match(/^(?=.*[0-9])/)) {
                    paswordErrors.push(t("The password should have at least one digit"));
                }
                setErrors(function (errors) { return (__assign(__assign({}, errors), { password: paswordErrors })); });
                break;
            case "password_confirmation":
                setErrors(function (errors) { return (__assign(__assign({}, errors), { confirmPassword: value !== form.data.password ? t("Passwords have to match") : "" })); });
                break;
            default:
                break;
        }
    }
    function onSubmit(token) {
        // verify recaptcha
        var site = window.location.protocol + "//" + window.location.host;
        axios_1.default.post(site + "/api/verify/recaptcha", { "g-recaptcha-response": token }).then(function (res) {
            form.data.reCaptcha = res.data.success;
        });
    }
    return (react_1.default.createElement("div", { className: "container-fluid", style: { fontFamily: "Geomanist" } },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-4 col-lg-4 col-xl-4 d-flex flex-column justify-content-center mx-xl-5 px-xl-5" },
                react_1.default.createElement(inertia_react_1.Head, { title: t("Register") }),
                react_1.default.createElement("div", { className: "d-flex flex-column justify-content-center my-3", style: { color: "var(--info-color)" } },
                    react_1.default.createElement("img", { src: "/images/qplayhorizontal.svg", className: "mx-auto", style: { width: "132px", height: "26px" } }),
                    !props.invitationFlow && react_1.default.createElement("h1", { className: "fw-bold text-center", style: { fontSize: "200%", fontFamily: "Geomanist-bold", marginTop: "1rem" } }, t("Try Q-Play for free"))),
                react_1.default.createElement("form", { onSubmit: formSubmit, id: "registerForm", className: "mt-4", "data-cy": "registerForm" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.default, { htmlFor: "name" }, t("Name")),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(Input_1.default, { id: "name", type: "text", className: "mt-1 block w-full", value: form.data.name, onChange: function (e) { return form.setData("name", e.currentTarget.value); }, required: true, autoFocus: true, autoComplete: "name", "data-cy": "nameInput" })),
                    react_1.default.createElement("div", { className: "mt-4" },
                        react_1.default.createElement(Label_1.default, { htmlFor: "company_name" }, t("Company Name")),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(Input_1.default, { id: "company_name", type: "text", className: "mt-1 block w-full", value: form.data.company_name, onChange: function (e) { return form.setData("company_name", e.currentTarget.value); }, required: true, autoComplete: "name", "data-cy": "companyNameInput", disabled: props.invitationFlow })),
                    react_1.default.createElement("div", { className: "mt-4" },
                        react_1.default.createElement(Label_1.default, { htmlFor: "email" }, t("Email")),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(Input_1.default, { id: "email", type: "email", className: form.data.email.length > 0 ? "is-invalid mt-1 block w-full" : "mt-1 block w-full", value: form.data.email, onChange: function (e) {
                                inputValidation(e);
                                form.setData("email", e.currentTarget.value);
                            }, required: true, "data-cy": "emailInput", disabled: props.invitationFlow }),
                        errors.email.length > 0 && (react_1.default.createElement("span", { className: "invalid-feedback" }, errors.email))),
                    react_1.default.createElement("div", { className: "mt-4" },
                        react_1.default.createElement(Label_1.default, { htmlFor: "phone_number" }, t("Phone Number")),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(Input_1.default, { id: "phone_number", type: "tel", className: form.data.phone_number.length > 0 ? "is-invalid mt-1 block w-full" : "mt-1 block w-full", value: form.data.phone_number, onChange: function (e) {
                                inputValidation(e);
                                form.setData("phone_number", e.currentTarget.value);
                            }, required: true, "data-cy": "phoneInput" }),
                        errors.phoneNumber.length > 0 && (react_1.default.createElement("span", { className: "invalid-feedback" }, errors.phoneNumber))),
                    react_1.default.createElement("div", { className: "mt-4" },
                        react_1.default.createElement(Label_1.default, { htmlFor: "password" }, t("Password")),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(Input_1.default, { id: "password", type: "password", className: form.data.password.length > 0 ? "is-invalid mt-1 block w-full" : "mt-1 block w-full", value: form.data.password, onChange: function (e) {
                                inputValidation(e);
                                form.setData("password", e.currentTarget.value);
                            }, required: true, autoComplete: "new-password", "data-cy": "passwordInput" }),
                        errors.password.length > 0 && (react_1.default.createElement("div", { className: "invalid-feedback d-flex flex-wrap" }, errors.password.map(function (error) { return (react_1.default.createElement("span", { key: error, style: { width: "100%" } }, error)); })))),
                    react_1.default.createElement("div", { className: "mt-4" },
                        react_1.default.createElement(Label_1.default, { htmlFor: "password_confirmation" }, t("Confirm Password")),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(Input_1.default, { id: "password_confirmation", type: "password", className: form.data.password_confirmation.length > 0 ? "is-invalid mt-1 block w-full" : "mt-1 block w-full", value: form.data.password_confirmation, onChange: function (e) {
                                inputValidation(e);
                                form.setData("password_confirmation", e.currentTarget.value);
                            }, required: true, autoComplete: "new-password", "data-cy": "passwordConfirmationInput" }),
                        errors.confirmPassword.length > 0 && (react_1.default.createElement("span", { className: "invalid-feedback" }, errors.confirmPassword))),
                    react_1.default.createElement("div", { className: "d-flex flex-nowrap align-items-center mt-2 mb-3" },
                        react_1.default.createElement(Checkbox_1.default, { name: "terms", id: "terms", checked: form.data.terms, onChange: function (e) { return form.setData("terms", e.currentTarget.checked); }, required: true, "data-cy": "termsInput" }),
                        react_1.default.createElement("div", { className: "ml-2", style: { fontSize: "15px" } },
                            "\u00A0",
                            t("Accept"),
                            "\u00A0",
                            react_1.default.createElement("a", { target: "_blank", href: "https://nordicscreen.com/terms-and-conditions/", className: "underline text-sm", style: { color: "var(--info-color)" }, rel: "noreferrer" }, t("Terms & Conditions")))),
                    react_1.default.createElement("div", { className: "mt-4" },
                        react_1.default.createElement(react_google_recaptcha_1.default
                        // https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do
                        , { 
                            // https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do
                            sitekey: process.env.APP_ENV !== "production" ? process.env.RECAPTCHA_TESTING_SITE_KEY : process.env.RECAPTCHA_SITE_KEY, onChange: onSubmit })),
                    sErrors && (react_1.default.createElement("div", { className: "mt-4 text-danger text-center", "data-cy": "errorsDiv" },
                        sErrors.email && (react_1.default.createElement("span", { "data-cy": "emailError" }, sErrors.email)),
                        sErrors.password && (react_1.default.createElement("span", { "data-cy": "passwordError" }, sErrors.password)))),
                    react_1.default.createElement("div", { className: "my-4" },
                        react_1.default.createElement("div", { className: "row m-0" },
                            react_1.default.createElement(q_play_components_1.Button, { text: props.invitationFlow ? t("Create user and accept the invitation") : t("Create Account"), className: (0, classnames_1.default)({ "opacity-25": form.processing }), isDisabled: form.processing, dataCy: "createAccountButton" }))),
                    react_1.default.createElement("div", { className: "mb-2" },
                        react_1.default.createElement("div", { className: "horizontal-divider" }, t("Or")),
                        react_1.default.createElement(SSO_1.default, { partner_id: props.partnerAccountId, text: "Sign up" })),
                    !props.invitationFlow ?
                        react_1.default.createElement("div", { className: "text-center text-sm mt-3", style: { color: "var(--info-color)" } },
                            react_1.default.createElement("label", null,
                                t("Already got an account?"),
                                "\u2002"),
                            react_1.default.createElement(inertia_react_1.InertiaLink, { href: route("login"), className: AuthPages_module_css_1.default.pageLink + " underline fw-bold" }, t("Log in")))
                        :
                            react_1.default.createElement(react_1.default.Fragment, null))),
            react_1.default.createElement("div", { className: "col d-none d-md-block", style: { backgroundColor: "#F5F9EB" } },
                react_1.default.createElement("div", { className: "vh-100 container d-flex align-self-center justify-content-center" },
                    react_1.default.createElement("div", { className: "d-flex align-items-center" },
                        react_1.default.createElement("img", { src: "/images/LoginPageGrabDesignShare.svg", className: "rounded mx-auto d-block img-fluid", style: { width: "80vh", height: "80vh" } })))))));
}
exports.default = Register;
